var _defs, _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16.65 8.74"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 2white")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "8.32 8.74 0 0.42 0.42 0 8.32 7.91 16.23 0 16.65 0.42 8.32 8.74"
})))));
export default __webpack_public_path__ + "static/media/arrow.2d3581bf.svg";
export { SvgComponent as ReactComponent };